import { Grid2, Theme } from '@mui/material';
import { SxProps } from '@mui/system';
import { LoadingButton } from '@mui/lab';
import type ModalHeader from './ModalHeader';

interface Props {
  submitButton?: React.ComponentProps<typeof ModalHeader>['submitButton'];
  secondaryButton?: React.ComponentProps<typeof ModalHeader>['secondaryButton'];
}

const BUTTON_STYLE: SxProps<Theme> = {
  borderRadius: '5px',
  height: '40px',
  fontWeight: 'bold',
  fontSize: '1rem',
};

function ModalBottomButtons({ submitButton, secondaryButton }: Props) {
  if (!submitButton && !secondaryButton) return null;

  return (
    <Grid2
      container
      columns={submitButton && secondaryButton ? 2 : 1}
      spacing={1}
      sx={{
        bottom: 0,
        position: 'sticky',
        width: '100%',
        right: 0,
        left: 0,
        mx: 'auto',
        p: 2,
        display: {
          xs: 'flex',
          sm: 'none',
        },
        justifyContent: 'center',
        alignItems: 'center',
        bgcolor: 'background.paper',
        boxSizing: 'border-box',
      }}>
      {secondaryButton && (
        <Grid2 size={1}>
          <LoadingButton
            type="button"
            variant="light"
            fullWidth
            sx={BUTTON_STYLE}
            disabled={secondaryButton.disabled}
            onClick={secondaryButton.onClick}>
            {secondaryButton.text}
          </LoadingButton>
        </Grid2>
      )}

      {submitButton && (
        <Grid2 size={1}>
          <LoadingButton
            type={submitButton.type}
            variant="contained"
            className="primary"
            fullWidth
            sx={BUTTON_STYLE}
            disabled={submitButton.disabled}
            onClick={submitButton.onClick}
            loading={submitButton.isLoading}>
            <span>{submitButton.text}</span>
          </LoadingButton>
        </Grid2>
      )}
    </Grid2>
  );
}

export default ModalBottomButtons;
